import Stripe from "stripe";
const stripe = new Stripe(process.env.STRIPE_SECRET_KEY as string, {
  apiVersion: "2020-08-27",
});
import { NextSeo } from "next-seo";
import Navbar from "../components/navbar";
import Footer from "../components/footer";
import DonationForm from "../components/donation-form";
import { NextApiRequest, NextApiResponse } from "next";

interface IDonateProps {
  prices: any[];
}

export default function Donate({ prices }: IDonateProps) {
  return (
    <div>
      <NextSeo title="Donate" />
      <Navbar />
      <DonationForm prices={prices} />
      <Footer />
    </div>
  );
}

export async function getServerSideProps() {
  const isPreview = process.env.VERCEL_ENV === "preview";

  console.log(`isPreview:`, isPreview);
  // const paymentIntent = await stripe.paymentIntents.create({
  //   amount: 5000,
  //   currency: "usd",
  //   description: "Donation",
  //   automatic_payment_methods: { enabled: true },
  // });
  const prices = await stripe.prices.list({
    product:
      process.env.NODE_ENV === "production" && !isPreview
        ? "prod_MBFsFsHQ4G7AR4"
        : "prod_8aenfRi5CbtyYU",
  });

  return {
    props: {
      // piId: paymentIntent.id,
      // clientSecret: paymentIntent.client_secret,
      prices: prices.data.sort(
        (a: any, b: any) => a.unit_amount - b.unit_amount
      ),
    },
  };
}
